<ion-row>
  <ion-col [ngClass]="{ 'alt-spacing': hasAltSpacing }" class="ion-no-padding">
    <ion-row class="header">
      {{ sectionHeader }}
    </ion-row>
    <ion-row class="break"></ion-row>
    <div class="button-grid">
      @for (button of buttons; track button) {
        <div class="button-wrapper">
          @if (roleUtils.showReports(button.enum, locationIdo, userRole)) {
            <app-report-button
              class="button-full-width"
              [buttonText]="button.text"
              [hasDownloadIcon]="button.downloadOnly"
              [hasArrowIcon]="!!button.hasArrowIcon"
              (emitButtonClick)="buttonClicked(button)"
            ></app-report-button>
          }
        </div>
      }
    </div>
  </ion-col>
</ion-row>
